import { render, staticRenderFns } from "./BusinessSignUpSuccessView.vue?vue&type=template&id=3785cf62"
import script from "./BusinessSignUpSuccessView.vue?vue&type=script&lang=js"
export * from "./BusinessSignUpSuccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports